import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        customers: false
      },
      options: {
        customers: []
      },
      selected: {
        customer: ''
      },
      editable: {
        customer: ''
      }
    }
  },

  methods: {

    async getCustomers (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.customer
      const fetching = context.fetching?.customers
      const options = context.options?.customers

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.customers = true
      context.selected.customer = ''

      const filters = {
        filter_text: search,
        cluster_id: context?.selected?.cluster?.id || ''
      }

      return await SSharedList.getCustomers(filters).then(
        ({ data }) => {
          context.options.customers = data
        }
      ).catch(() => {
        context.options.customers = []
      }).finally(() => {
        context.fetching.customers = false
      })
    },

    async searchCustomers (search, loading) {
      this.searchCustomersProvider(this, search, loading)
    },

    searchCustomersProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.customers, {
          keys: ['customer_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            cluster_id: selected?.cluster?.id || ''
          }

          SSharedList.getCustomers(filters).then(
            ({ data }) => {
              options.customers = data
            }
          ).catch(() => {
            options.customers = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
